import request from '@/utils/request'
import axios from "axios";
import { addUrlPerFix } from "@/utils";


// 开店店铺信息查询
export function queryAddShopInfo(data) {
  return request({
    url: '/apis/sra/store/users/signup/queryAddShopInfo', // 后端接口
    method: 'post',
    data
  })
}
// 云租开店接口
export function addShopByClp(data) {
  return request({
    url: '/apis/sra/store/users/signup/addShopByClp', // 后端接口
    method: 'post',
    data
  })
}
//查询供货商信息
export function qrySupInfoListItem(data) {
  return request({
    url: '/apis/sra/smc/users/signup/qrySupInfoListItem', // 后端接口
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}
//查询供货商信息
export function shopSubmit(data) {
  return request({
    url: '/apis/sra/oc/users/signup/shopSubmit', // 后端接口
    method: 'post',
    data
  })
}//查询供货商信息
export function getWayChatPay(data) {
  return request({
    url: '/apis/sra/oc/users/signup/getWayChatPay', // 后端接口
    method: 'post',
    data
  })
}
// 查询支付状态
export function getStatus(data) {
  return request({
    url: '/apis/sra/oc/users/signup/getStatus', // 后端接口
    method: 'post',
    data
  })
}

// 附件下载  合作框架协议
export function templateDownloadhzkjxy(data) {
  const baseURL = addUrlPerFix(process.env.VUE_APP_BASE_URL);
  return axios.create().post(
    baseURL + "/apis/sra/oss/users/signup/templateDownload/hzkjxy",
    data,
    {
      responseType: "blob"
    }
  );
}

// 附件下载 物流
export function templateDownloadwlxt(data) {
  const baseURL = addUrlPerFix(process.env.VUE_APP_BASE_URL);
  return axios.create().post(
    baseURL + "/apis/sra/oss/users/signup/templateDownload/wlxt",
    data,
    {
      responseType: "blob"
    }
  );
}

// 附件下载 租赁
export function templateDownloadzlxt(data) {
  const baseURL = addUrlPerFix(process.env.VUE_APP_BASE_URL);
  return axios.create().post(
    baseURL + "/apis/sra/oss/users/signup/templateDownload/zlxt",
    data,
    {
      responseType: "blob"
    }
  );
}
// 附件下载 二级集采
export function templateDownloadjcxt(data) {
  const baseURL = addUrlPerFix(process.env.VUE_APP_BASE_URL);
  return axios.create().post(
    baseURL + "/apis/sra/oss/users/signup/templateDownload/jcxt",
    data,
    {
      responseType: "blob"
    }
  );
}

export function getUserInfo(data) {
  return request({
    url:addUrlPerFix(process.env.VUE_APP_BASEP_URL) + "/apis/basap/getUserInfo",
    method: "post",
    data
  });
}

// 附件下载 仓库方
export function templateDownloadckxt(data) {
  const baseURL = addUrlPerFix(process.env.VUE_APP_BASE_URL);
  return axios.create().post(
    baseURL + "/apis/sra/oss/users/signup/templateDownload/ckxt",
    data,
    {
      responseType: "blob"
    }
  );
}
// 主数据国家地址
export function qryAreaAddressLogin(data) {
  return request({
    url: `/apis/sra/common/users/signup/qryAreaAddressLogin`,
    method: "POST",
    data
  });
}

// 主数据国家地址
export function qryAllProForTwo(data) {
  return request({
    url: `/apis/sra/users/signup/subconauthaccountinfo/qryAllProForTwo`,
    method: "POST",
    data
  });
}

// 物流店铺年费配置信息查询
export function qryShopfeeCompanyBillConfig(data) {
  return request({
    url: `/apis/sra/oc/users/signup/qryShopfeeCompanyBillConfig`,
    method: "POST",
    data
  });
}

// 物流店铺年费公对公保存账单信息
export function saveShopfeeCompanyTransferBill(data) {
  return request({
    url: `/apis/sra/oc/users/signup/saveShopfeeCompanyTransferBill`,
    method: "POST",
    data
  });
}

// 开始审批
export function startProcess(data) {
  return request({
    url: `/apis/sra/spc/users/signup/startProcess`,
    method: "POST",
    data
  });
}



// 物资类别数据-basa全量
export function qryMatCatery100001Tree(data) {
  return request({
    url: '/apis/sra/basic/users/signup/qryMatCatery100001Tree',
    method: 'post',
    data,
  });
}

// 物资类别数据-basa全量
export function selectSecondPurchaseCategory(data) {
  return request({
    url: '/apis/sra/spc/category/users/signup/selectSecondPurchaseCategory',
    method: 'post',
    data,
  });
}
// 物流-查询意向合作关系列表
export function queryCooperativeRelationshipList(data) {
  return request({
    url: '/apis/sra/smc/users/signup/queryCooperativeRelationshipList',
    method: 'post',
    data,
  });
}
